/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("resultDialogModule", []).
controller("resultDialogCtrl", ["$scope", "$modalInstance", "options", function($scope, $modalInstance, options) {
	initStatus();
	initData();

	function initStatus() {
		$scope.result = options;
	}

	function initData() {
	}
	$scope.cancel = function() {
		$modalInstance.dismiss();
	};
}]);